<template>
    <v-card flat class="mb-3">
        <div>
            <v-layout row wrap>
                <v-flex xs12 lg8 offset-lg2>
                    <v-card flat class="mt-3 pa-1"  v-if="inputData">
                        <v-flex xs12 >
                            <v-form ref="form">
                                <v-layout row wrap>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="name"
                                                label="Nosaukums"
                                                color="deep-purple accent-3"
                                                :rules="formRules"
                                                required
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md4>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="unNr"
                                                type="number"
                                                label="UN numurs"
                                                color="deep-purple accent-3"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md4 >
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="cleaningProgram"
                                                color="deep-purple accent-3"
                                                :items="inputData.cleaningPrograms"
                                                label="Mazgāšanas programma"
                                        ></v-autocomplete>
                                    </v-flex>

                                </v-layout>
                            </v-form>
                        </v-flex>


                        <v-layout row wrap>
                            <v-flex xs12 class="mx-3 mb-3">
                                <div class="text-xs-center text-md-right">
                                    <v-btn small flat @click="hideAddCargoForm" dark color="deep-orange lighten-1">
                                        <v-icon dark left>block</v-icon>Atcelt</v-btn>
                                    <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                                        <v-icon dark right>check_circle</v-icon>
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>

        </div>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "add-container",
        data: () => ({
            name: '',
            unNr: '',
            cleaningProgram: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        mounted() {
            this.$store.dispatch('getCargoInputData')
        },
        computed: {
            ...mapGetters({
                inputData: 'cargoInputData'
            })
        },
        methods: {
            hideAddCargoForm(){
                this.$store.dispatch('hideAddCargoForm')
            },
            submit() {
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewCargo', {
                        name: this.name,
                        unNr: this.unNr,
                        cleaningProgram: this.cleaningProgram
                    })
                    this.$parent.snackbar = true
                    this.$parent.color = 'green'
                    this.$parent.text = 'Krava pievienota'
                } else {
                    this.$Progress.fail()
                }
            }
        }
    }
</script>

<style scoped>

</style>